import { EDITOR_CONSTANTS } from "@perceptron/constants/editorConstants";
import { JSONContent } from "@tiptap/react";

import { MediaSetContainerAttributes } from "@demo/types/media";

// Re-export for backward compatibility
export type MediaSetContainerAttrs = MediaSetContainerAttributes;

export interface MediaSetContainerNode extends JSONContent {
  type: typeof EDITOR_CONSTANTS.NODE_TYPES.MEDIA_SET_CONTAINER;
  attrs: MediaSetContainerAttrs;
}

/**
 * Creates a mediaSetContainer node with all required attributes.
 *
 * IMPORTANT: This factory function ensures consistency with TipTap's MediaSetContainerExtension.
 * Always use this instead of manually creating mediaSetContainer objects to prevent
 * attribute inconsistency bugs between saved content and editor content.
 *
 * Type Safety:
 * - Parameters are typed against MediaSetContainerAttributes
 * - Return type is strictly typed to match TipTap's expectations
 * - If TipTap extension adds new attributes, this function will require updates
 *
 * @param id - Unique identifier for the media set (or null for TipTap default)
 * @param mediaIds - Array of media item IDs in this set
 * @returns Properly structured mediaSetContainer node for TipTap
 */
export const createMediaSetContainerNode = (id: string | null, mediaIds: string[] = []): MediaSetContainerNode => ({
  type: EDITOR_CONSTANTS.NODE_TYPES.MEDIA_SET_CONTAINER,
  attrs: { id, mediaIds },
});
